"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _FaICIconMap = require("./../../FaICIconMap");

require("./../ToolbarButtonWrapper.css");

require("./BlockInlineToolbarTool.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getRelativeParent = function getRelativeParent(element) {
  if (!element) {
    return null;
  }

  var position = window.getComputedStyle(element).getPropertyValue('position');

  if (position !== 'static') {
    return element;
  }

  return getRelativeParent(element.parentElement);
};

var alignButtons = [{
  icon: _FaICIconMap.faAlignLeft,
  "action": "left"
}, {
  icon: _FaICIconMap.faAlignCenter,
  "action": "center"
}, {
  icon: _FaICIconMap.faAlignRight,
  "action": "right"
}];
var sizeButtons = [{
  icon: _FaICIconMap.faSquareFull,
  "action": "big",
  "imgWidth": 100
}, {
  icon: _FaICIconMap.faSquareFull,
  "action": "medium",
  "imgWidth": 75
}, {
  icon: _FaICIconMap.faSquareFull,
  "action": "small",
  "imgWidth": 50
}];

var BlockInlineToolbarTool = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BlockInlineToolbarTool, _React$Component);

  function BlockInlineToolbarTool() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      position: {},
      alignment: null,
      size: null,
      width: 100
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibilityChanged", function (visibleBlock) {
      setTimeout(function () {
        var position;

        var boundingRect = _this.props.store.getItem('boundingRect');

        if (visibleBlock) {
          var relativeParent = getRelativeParent(_this.toolbar.parentElement);
          var toolbarHeight = _this.toolbar.clientHeight;
          var relativeRect = relativeParent ? relativeParent.getBoundingClientRect() : document.body.getBoundingClientRect();
          position = {
            top: boundingRect.top - relativeRect.top - toolbarHeight,
            left: boundingRect.left - relativeRect.left + boundingRect.width / 2,
            transform: 'translate(-50%) scale(1)',
            transition: 'transform 0.15s cubic-bezier(.3,1.2,.2,1)'
          };
        } else {
          position = {
            transform: 'translate(-50%) scale(0)'
          };
        }

        var alignment = _this.props.store.getItem('alignment') || 'default';
        var size = _this.props.store.getItem('size') || 'default';
        var width = _this.props.store.getItem('width') || 100;

        _this.setState({
          alignment: alignment,
          position: position,
          size: size,
          width: width
        });
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "onWidthChange", function (width) {
      _this.setState({
        width: width
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAlignmentChange", function (alignment) {
      _this.setState({
        alignment: alignment
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSizeChange", function (size) {
      _this.setState({
        size: size
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickAlignment", function (event) {
      event.preventDefault();

      _this.props.store.getItem('updateData')({
        "alignment": event.currentTarget.id
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClickSize", function (event) {
      event.preventDefault();
      var item = sizeButtons[event.currentTarget.id];

      _this.props.store.getItem('updateData')({
        "size": item.action,
        "width": item.imgWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "preventBubblingUp", function (event) {
      event.preventDefault();
    });

    return _this;
  }

  var _proto = BlockInlineToolbarTool.prototype;

  _proto.componentWillMount = function componentWillMount() {
    this.props.store.subscribeToItem('visibleBlock', this.onVisibilityChanged);
    this.props.store.subscribeToItem('alignment', this.onAlignmentChange);
    this.props.store.subscribeToItem('size', this.onSizeChange);
    this.props.store.subscribeToItem('width', this.onWidthChange);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.store.unsubscribeFromItem('visibleBlock', this.onVisibilityChanged);
    this.props.store.unsubscribeFromItem('alignment', this.onAlignmentChange);
    this.props.store.unsubscribeFromItem('size', this.onSizeChange);
    this.props.store.unsubscribeFromItem('width', this.onWidthChange);
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "block-inline-toolbar-tool",
      style: this.state.position,
      ref: function ref(toolbar) {
        _this2.toolbar = toolbar;
      }
    }, alignButtons.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "toolbarButtonWrapper",
        key: index,
        onMouseDown: _this2.preventBubblingUp
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "toolbarButton " + (_this2.state.alignment === item.action ? 'active' : ''),
        id: item.action,
        onClick: _this2.onClickAlignment
      }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
        icon: item.icon
      })));
    }), sizeButtons.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "toolbarButtonWrapper",
        key: index,
        onMouseDown: _this2.preventBubblingUp
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "toolbarButton size-" + item.action,
        id: index,
        onClick: _this2.onClickSize
      }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
        icon: item.icon
      })));
    }));
  };

  return BlockInlineToolbarTool;
}(_react["default"].Component);

exports["default"] = BlockInlineToolbarTool;
module.exports = exports.default;